// ICICI Payment Gateway Configuration
// File: src/config/paymentConfig.js

// ICICI Payment Gateway Configuration

// const ICICI_CONFIG = {
//   MERCHANT_ID: "T_03342",
//   WORKING_KEY: "abc",
//   ACCESS_CODE: "AVIA01",
//   GATEWAY_URL: "https://qa.phicommerce.com/pg/api/v2/initiateSale",
//   RETURN_URL: "http://localhost:5173/payment/return",
//   CANCEL_URL: "http://localhost:5173/payment/cancel",
// };
const PAYMENT_CONFIG = {
  // UAT Environment (Development)
  UAT: {
    MERCHANT_ID: "T_03342",
    ACCESS_CODE: "AVXK01",
    WORKING_KEY: "abc",
    GATEWAY_URL: "https://phicommerce.com/pg/api/v2/initiateSale",
    RETURN_URL: "http://localhost:5173/payment/return",
    CANCEL_URL: "http://localhost:5173/payment/cancel",
  },

  // Production Environment
  PRODUCTION: {
    MERCHANT_ID: import.meta.env.VITE_MERCHANT_ID || "YOUR_PROD_MERCHANT_ID",
    ACCESS_CODE: import.meta.env.VITE_ACCESS_CODE || "YOUR_PROD_ACCESS_CODE",
    WORKING_KEY: import.meta.env.VITE_WORKING_KEY || "YOUR_PROD_WORKING_KEY",
    GATEWAY_URL: "https://phicommerce.com/pg/api/v2/initiateSale",
    RETURN_URL:
      import.meta.env.VITE_RETURN_URL ||
      "https://yourdomain.com/payment/return",
    CANCEL_URL:
      import.meta.env.VITE_CANCEL_URL ||
      "https://yourdomain.com/payment/cancel",
  },
};

// Get current environment configuration
const getPaymentConfig = () => {
  const isDevelopment = true;
  // const isDevelopment = import.meta.env.MODE === "development";
  return isDevelopment ? PAYMENT_CONFIG.UAT : PAYMENT_CONFIG.PRODUCTION;
};

// Payment Status Codes
const PAYMENT_STATUS = {
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
  CANCELLED: "CANCELLED",
  REFUNDED: "REFUNDED",
};

// ICICI Response Codes
const ICICI_RESPONSE_CODES = {
  SUCCESS: "000",
  PENDING: "001",
  FAILED: "002",
  CANCELLED: "003",
  INVALID_REQUEST: "004",
  DUPLICATE_TRANSACTION: "005",
};

// Check if response is successful
const isSuccessfulResponse = (responseCode) => {
  return responseCode === ICICI_RESPONSE_CODES.SUCCESS;
};

// Payment Method Types
const PAYMENT_METHODS = {
  CASH: "cash",
  ONLINE: "online",
  CARD: "card",
  UPI: "upi",
};

// Validation Rules
const VALIDATION_RULES = {
  MIN_AMOUNT: 1.0,
  MAX_AMOUNT: 100000.0,
  MIN_PHONE_LENGTH: 10,
  MAX_PHONE_LENGTH: 15,
  MIN_EMAIL_LENGTH: 5,
  MAX_EMAIL_LENGTH: 100,
};

// Error Messages
const ERROR_MESSAGES = {
  INVALID_AMOUNT: "Amount must be between ₹1 and ₹1,00,000",
  INVALID_PHONE: "Please enter a valid phone number",
  INVALID_EMAIL: "Please enter a valid email address",
  INVALID_NAME: "Please enter a valid name",
  PAYMENT_FAILED: "Payment failed. Please try again.",
  NETWORK_ERROR: "Network error. Please check your connection.",
  GATEWAY_ERROR: "Payment gateway error. Please try again later.",
  INVALID_RESPONSE: "Invalid response from payment gateway.",
};

// Success Messages
const SUCCESS_MESSAGES = {
  PAYMENT_INITIATED: "Payment initiated successfully!",
  PAYMENT_SUCCESS: "Payment completed successfully!",
  PAYMENT_PENDING: "Payment is being processed...",
  REFUND_SUCCESS: "Refund processed successfully!",
};

// API Endpoints (if you have a backend for status checks)
const API_ENDPOINTS = {
  PAYMENT_STATUS: "/api/payments/status",
  PAYMENT_HISTORY: "/api/payments/history",
  REFUND_PAYMENT: "/api/payments/refund",
};

export {
  PAYMENT_CONFIG,
  getPaymentConfig,
  PAYMENT_STATUS,
  ICICI_RESPONSE_CODES,
  isSuccessfulResponse,
  PAYMENT_METHODS,
  VALIDATION_RULES,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
  API_ENDPOINTS,
};
